import modules from '@/modules';
const configMixin = {
  methods: {
    buildRoute(module) {
      let moduleIndex = modules.MODULES_BY_MODULE_TYPE[module?.type];
      if (moduleIndex) {
        let path = moduleIndex.api;
        return module.instance ? `/${path}/${module.instance}` : `/${path}`;
      }
      return '/';
    },

    getModuleId(module) {
      let moduleIndex = modules.MODULES_BY_MODULE_TYPE[module.type];
      return moduleIndex ? moduleIndex.moduleId : '';
    },
    /**
     * Get the unread count of a given module
     * @param {Object} module module configuration
     * @returns the count of unread items
     */
    mx_unreadCount(module) {
      if (!module) return 0;

      let unreadCount = 0;
      let moduleId = this.getModuleId(module);
      if (moduleId && module.hasBadge) {
        unreadCount = this.$store.getters[`${moduleId}/getUnreadCountByModuleInstance`](module.instance);
      }
      // console.debug('mx_unreadCount of module',moduleId, module.instance,module.type,unreadCount);
      return unreadCount ? unreadCount : 0;
    },
  },
};

export default configMixin;
